//企业路由管理
export default [
	// 企业管理列表
	// {
	// 	path: '/enterpriselist',
	// 	name: 'enterpriselist',
	// 	meta: {
	// 		index: 3,
	// 		keepAlive: true,
	// 	},
	// 	component: () => import('../../views/enterprise/enterpriseList.vue')
	// },
	// 选择企业认证方式
	// {
	// 	path: '/selectenterpriseauthstyle',
	// 	name: 'selectenterpriseauthstyle',
	// 	meta: {
	// 		index: 4,
	// 		keepAlive: false,
	// 	},
	// 	component: () => import(
	// 		'../../views/enterprise/auth/selectEnterpriseAuthStyle.vue')
	// },
	// 上传企业文件
	{
		path: '/authenterpriseinfo',
		name: 'authenterpriseinfo',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import(
			'../../views/enterprise/auth/authEnterpriseInfo.vue')
	},
	// 添加或确认企业信息
	// {
	// 	path: '/addenterpriseinfo',
	// 	name: 'addenterpriseinfo',
	// 	meta: {
	// 		index: 4,
	// 		keepAlive: false,
	// 	},
	// 	component: () => import(
	// 		'../../views/enterprise/auth/addEnterpriseInfo.vue')
	// },
	// 上传企业授权书和经办人信息
	{
		path: '/authenterpriselegal',
		name: 'authenterpriselegal',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import(
			'../../views/enterprise/auth/authEnterpriseLegal.vue')
	},
	// 上传企业印章
	// {
	// 	path: '/uploadenterpriseseal',
	// 	name: 'uploadenterpriseseal',
	// 	meta: {
	// 		index: 4,
	// 		keepAlive: false,
	// 	},
	// 	component: () => import('../../views/enterprise/auth/uploadEnterpriseSeal.vue')
	// },
	// 企业向平台打款认证状态
	{
		path: '/authenterprisestatus',
		name: 'authenterprisestatus',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/enterprise/auth/authEnterpriseStatus.vue')
	},
	// CA申请资料修改
	{
		path: '/editenterprisecaapplyinfo',
		name: 'editenterprisecaapplyinfo',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/enterprise/ca/editEnterpriseCAApplyInfo.vue')
	},
	// CA申请资料状态
	{
		path: '/enterprisecaapplystatus',
		name: 'enterprisecaapplystatus',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/enterprise/ca/enterpriseCAApplyStatus.vue')
	},
	// 创建企业
	{
		path: '/addenterprise',
		name: 'addenterprise',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/enterprise/auth/addEnterprise.vue')
	},
	// 企业法人验证人脸
	// {
	// 	path: '/authenterpriselegalface',
	// 	name: 'authenterpriselegalface',
	// 	meta: {
	// 		index: 4,
	// 		keepAlive: false,
	// 	},
	// 	component: () => import(
	// 		'../../views/enterprise/auth/addEnterpriseLegalFace.vue')
	// },
	// 加入企业
	{
		path: '/joinenterprise',
		name: 'joinenterprise',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/enterprise/join/joinEnterprise.vue')
	},
	// 加入企业状态
	{
		path: '/joinenterprisestatus',
		name: 'joinenterprisestatus',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import(
			'../../views/enterprise/join/joinEnterpriseStatus.vue')
	},
	// 企业详情
	{
		path: '/enterpriseinfo',
		name: 'enterpriseinfo',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import(
			'../../views/enterprise/management/enterpriseInfo.vue')
	},

	// 企业成员管理
	{
		path: '/enterprisemembermanage',
		name: 'enterprisemembermanage',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import(
			'../../views/enterprise/management/enterpriseMemberManage.vue')
	},
	// 企业成员管理
	{
		path: '/newmemberapply',
		name: 'newmemberapply',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/enterprise/management/newMemberApply.vue')
	},
	// 企业成员详情
	{
		path: '/memberinfo',
		name: 'memberinfo',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/enterprise/management/memberInfo.vue')
	},

	// 企业成员分享邀请同事
	{
		path: '/shareinvitemember',
		name: 'shareinvitemember',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import(
			'../../views/enterprise/management/shareInviteMember.vue')
	},

	// 企业成员邀请同事
	{
		path: '/invitemember',
		name: 'invitemember',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/enterprise/management/inviteMember.vue')
	},


	//印章列表
	{
		path: '/signetlist',
		name: 'signetlist',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/signetcert/signetList.vue')
	},

	//添加印章
	{
		path: '/addsignet',
		name: 'addsignet',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/signetcert/addSignet.vue')
	},

	//修改印章
	{
		path: '/editsignet',
		name: 'editsignet',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/signetcert/editSignet.vue')
	},
	
	
	//印章详情
	{
		path: '/signetinfo',
		name: 'signetinfo',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/signetcert/signetInfo.vue')
	},

]